import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import { InvoiceIcon } from 'foundations-assets/icons/components/InvoiceIcon';
import { PaymentSubscriptionsIcon } from 'foundations-assets/icons/components/PaymentSubscriptionsIcon';
import { WalletIcon } from 'foundations-assets/icons/components/WalletIcon';
import { TicketIcon } from 'foundations-assets/icons/components/TicketIcon';
import { DealsIcon } from 'foundations-assets/icons/components/DealsIcon';
import { HomeIcon } from 'foundations-assets/icons/components/HomeIcon';
import { ChecklistIcon } from 'foundations-assets/icons/components/ChecklistIcon';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';
import { SalesQuoteIcon } from 'foundations-assets/icons/components/SalesQuoteIcon';
import { TeamworkIcon } from 'foundations-assets/icons/components/TeamworkIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const ICON_MAP = {
  billing: CreditCardIcon,
  'billing.subscriptions': PaymentSubscriptionsIcon,
  'billing.invoices': InvoiceIcon,
  'billing.payment-methods': CreditCardIcon,
  'billing.payment-history': WalletIcon,
  'billing.quotes': SalesQuoteIcon,
  teamwork: TeamworkIcon,
  'home-app': HomeIcon,
  tickets: TicketIcon,
  deals: DealsIcon,
  onboarding: ChecklistIcon,
  reference: DocumentsIcon,
  'reference.component-examples': DocumentsIcon,
  'reference.token-explorer': DocumentsIcon,
  'reference.projects': DocumentsIcon,
  'reference.forms': DocumentsIcon
};
export function PortalsSideNavIcon({
  name
}) {
  const Icon = name && ICON_MAP[name] ? ICON_MAP[name] : HomeIcon;
  return /*#__PURE__*/_jsx(Icon, {
    color: "text-core-default",
    size: '500',
    "aria-hidden": true
  });
}